export const fmtMoney = (n, digits = 0) => {
  if (n == null || isNaN(n)) return "$0";
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const fmtNumber = (n, digits = 0) => {
  if (n == null || isNaN(n)) return "0";
  return Number(n).toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const fmtPercent = (n, digits = 1) => {
  if (n == null || isNaN(n)) return "0%";
  return `${(n * 100).toFixed(digits)}%`;
};

export const fmtMultiple = (n, digits = 2) => {
  if (n == null || isNaN(n)) return "0×";
  return `${Number(n).toFixed(digits)}×`;
};
